"use client"
import { useState } from "react"
import { ButtonFluxi } from "../common/Buttons/ButtonFluxi/ButtonFluxi"
import { cancelMembership } from "../../services/membership/MembershipAxios"
import toast from "react-hot-toast"

interface FeedbackModalProps {
	isOpen: boolean
	onClose: () => void
}

export function FeedbackModal({ isOpen, onClose }: FeedbackModalProps) {
	if (!isOpen) return null
	const [feedback, setFeedback] = useState("")

	const handleCancel = () => {
		if (feedback.length < 5) {
			toast.error("El feedback debe tener al menos 5 caracteres")
			return
		}
		cancelMembership(feedback)
			.then(() => {
				onClose()
				toast.success("Suscripción cancelada correctamente")
			})
			.catch((error) => {
				toast.error("Error al cancelar la suscripción")
				console.error(error)
			})
	}

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center">
			{/* Backdrop */}
			<div className="absolute inset-0 bg-black/50" onClick={onClose} />

			{/* Modal */}
			<div className="relative bg-white rounded-lg shadow-lg w-full max-w-md mx-4 p-6">
				{/* Close button */}
				<button
					onClick={onClose}
					className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-xl font-bold"
				>
					×
				</button>

				{/* Content */}
				<div className="space-y-6">
					<h2 className="text-xl font-semibold text-center text-gray-900">
						Ya quedó cancelada tu renovación automática, lamentamos verte ir y esperamos que vuelvas pronto
					</h2>

					<p className="text-gray-600 text-center">
						¿Por qué cancelaste tu suscripción? ¿Cómo podemos mejorar Fluxi para que te sirva mejor en un futuro?
					</p>

					<textarea value={feedback} onChange={(e) => setFeedback(e.target.value)} className="w-full border border-gray-300 rounded-lg p-2" placeholder="Escribe tu mensaje aquí" />

					<div className="flex items-center justify-center gap-2">
						<div className="flex items-center justify-center gap-2 w-full">
							<ButtonFluxi
								style={{
									fontSize: "16px",
									paddingTop: "10px",
									paddingBottom: "10px",
									minWidth: "100%",
									maxHeight: "40px",
									width: "100%"
								}}
								onClick={handleCancel}
							>
								Enviar feedback
							</ButtonFluxi>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
